import { render, staticRenderFns } from "./InformationPage.vue?vue&type=template&id=0cbf03a8&"
import script from "./InformationPage.vue?vue&type=script&lang=js&"
export * from "./InformationPage.vue?vue&type=script&lang=js&"
import style0 from "./InformationPage.vue?vue&type=style&index=0&id=0cbf03a8&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports